module.exports = __webpack_public_path__ + "img/card_cosmetics_200.c60e128c.jpg";